import React, { useEffect } from "react";
import { getValueByKeyObject } from "../../helpers/functions";
import { Alert, FormGroup, Input, Label } from "reactstrap";
import { InputDateGroup } from "../Common/InputDateGroup";
import { InputTimeGroup } from "../Common/InputTimeGroup";
import ComboBoxAutomatic from "./ComboBoxAutomatic";

const TranspaleStringToComponente = ({
  elementId,
  elementProps = {
    value: "",
    maxChacteres: 100,
    type: "", // Date | Texto | Combobox | input
    title: "",
    id: "",
    placeholder: "",
    required: false,
    isDisabled: false,
    alienated: [],
    isMultiSelection: false,
    procedure: "",
    procedureParams: "",
    dataOptions: [],
  },
  preFilter = [],
  onPreFilter = () => {},
  onDefaultValue = () => {},
}) => {
  function handlePreFilter({ value, field }, id, isDefaultValue = false) {
    onPreFilter({ [id]: { value, field } });
    if (isDefaultValue) {
      onDefaultValue({ [id]: { value, field } });
    }
  }

  const automaticElements = () => {
    let defaultValue = elementProps?.value;
    let maxLength = Number(elementProps?.maxChacteres) || null;

    switch (elementProps?.type) {
      case "Date":
        return (
          <FormGroup>
            <Label className="text-color-cinza4">{elementProps?.title}</Label>
            <InputDateGroup
              id={elementProps?.id}
              value={
                preFilter[0]?.[elementProps?.id]?.value
                  ?.split("/")
                  ?.reverse()
                  ?.join("-") ||
                defaultValue?.split("/")?.reverse()?.join("-") ||
                ""
              }
              onChange={(e) =>
                handlePreFilter(
                  {
                    value: e.target.value.split("-").reverse().join("/"),
                    field: elementProps?.title,
                  },
                  elementProps?.id,
                )
              }
              placeholder={elementProps?.placeholder || "dd/mm/aaaa"}
              maxDate={elementProps?.maxDate}
            />
          </FormGroup>
        );
      case "Time":
        return (
          <FormGroup className={elementProps?.formGroupClassName}>
            {elementProps?.title && (
              <Label className="text-color-cinza4">{elementProps.title}</Label>
            )}

            <InputTimeGroup
              id={elementProps?.id}
              value={
                preFilter[0]?.[elementProps?.id]?.value || defaultValue || ""
              }
              onChange={
                elementProps?.onChange
                  ? elementProps.onChange
                  : (e) =>
                      handlePreFilter(
                        {
                          value: e.target.value,
                          field: elementProps?.title,
                        },
                        elementProps?.id,
                      )
              }
              placeholder={elementProps?.placeholder || "00:00"}
              disabled={elementProps?.isDisabled}
            />
          </FormGroup>
        );
      case "Texto":
        return (
          <FormGroup>
            <span id={elementProps?.id}>{defaultValue}</span>
          </FormGroup>
        );
      case "Input":
        const alienadoInput = JSON.parse(elementProps?.alienated || "{}");

        return (
          <FormGroup>
            <Label className="text-color-cinza4">{elementProps?.title}</Label>
            <input
              name={elementProps?.id}
              className="form-control"
              id={elementProps?.id}
              defaultValue={
                preFilter[0]?.[elementProps?.id]?.value || defaultValue || ""
              }
              onChange={(e) =>
                handlePreFilter(
                  {
                    value: e.target.value,
                    field: elementProps?.title,
                  },
                  elementProps?.id,
                )
              }
              disabled={
                elementProps?.isDisabled ||
                (typeof alienadoInput === "object" &&
                  preFilter.some(
                    (obj) =>
                      Object.prototype.hasOwnProperty.call(
                        obj,
                        alienadoInput,
                      ) && !!obj[alienadoInput].value,
                  ))
              }
              placeholder={elementProps?.placeholder || ""}
              maxLength={maxLength}
            />
          </FormGroup>
        );
      case "Combobox":
        const id = elementProps?.id;
        const title = elementProps?.title;
        const procName = elementProps?.procedure;
        const procParams = elementProps?.procedureParams;
        const dataOptions = elementProps?.dataOptions || [];
        let valueOptions = [];

        try {
          valueOptions = value;
        } catch (error) {
          // console.log(`${id}: Combobox sem dados pré carregados`);
        }

        try {
          defaultValue = JSON.parse(defaultValue)[0];
        } catch (error) {
          // console.log(`${id}: Combobox sem valor padrão`);
        }

        const value = (preFilter[0] && preFilter[0][id]) || defaultValue || "";

        const alienado = elementProps?.alienated || [];

        const isMulti = elementProps?.isMultiSelection;

        return (
          <ComboBoxAutomatic
            id={id}
            titulo={title}
            placeholder={elementProps?.placeholder || "Selecionar"}
            isDisabled={
              elementProps.isDisabled ||
              (typeof alienado === "object" &&
                alienado.length &&
                !preFilter.some((obj) =>
                  Object.prototype.hasOwnProperty.call(obj, alienado),
                ))
            }
            idAlienated={alienado}
            alienated={
              typeof alienado === "object" && preFilter[0]
                ? getValueByKeyObject(preFilter, alienado)
                : []
            }
            maxLength={maxLength}
            procName={procName}
            procParams={procParams}
            initialValue={value}
            isMulti={isMulti}
            valueOptions={valueOptions}
            dataOptions={dataOptions}
            callbackSelected={(selected) => {
              onPreFilter({ ...preFilter[0], ...selected });
            }}
            formGroupClassName={elementProps?.formGroupClassName}
            callbackRemoveSelected={(id) => {
              const newPreFilter = preFilter[0];
              delete newPreFilter[id];
              onPreFilter(newPreFilter);
            }}
          />
        );
      case "Radio":
        return (
          <div className="form-group d-flex align-items-center gap-2">
            <Input
              className="input-radio-custom m-0"
              type="radio"
              value={elementProps?.value}
              checked={elementProps?.checked || undefined}
              name={elementProps?.name}
              disabled={elementProps?.isDisabled}
              id={elementProps?.id}
              onChange={(e) =>
                handlePreFilter(
                  {
                    value: e.target.value,
                    field: elementProps?.title,
                  },
                  elementProps?.id,
                )
              }
            />
            <Label className="text-color-cinza5 font-size-12 p-0 m-0">
              {elementProps?.title}
            </Label>
          </div>
        );
      case "Checkbox":
        return (
          <div className="form-group d-flex align-items-center gap-2">
            <Input
              className="input-checkbox-custom"
              type="checkbox"
              value={elementProps?.value}
              checked={elementProps?.checked || undefined}
              name={elementProps?.name}
              disabled={elementProps?.isDisabled}
              id={elementProps?.id}
              onChange={(e) =>
                handlePreFilter(
                  {
                    value: elementProps?.value,
                    field: elementProps?.field,
                  },
                  elementProps?.id,
                )
              }
            />
          </div>
        );
      default:
        return (
          <Alert className="my-2" color="warning">
            Input não mapeado
          </Alert>
        );
    }
  };

  useEffect(() => {
    if (elementProps?.value && !preFilter[elementProps?.id]) {
      handlePreFilter(
        {
          value: elementProps?.value,
          field: elementProps?.title,
        },
        elementProps?.id,
        true,
      );
    }
  }, []);

  return (
    <div key={elementId} className="transpale-wrapper">
      {automaticElements()}
    </div>
  );
};

export default TranspaleStringToComponente;
